var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisitorInfo = function SvgVisitorInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.524 14.063a2.382 2.382 0 0 0 1.519-2.998 2.362 2.362 0 0 0-2.981-1.527 2.382 2.382 0 0 0-1.518 2.998 2.362 2.362 0 0 0 2.98 1.527ZM12.688 6.304a1.62 1.62 0 0 0 1.032-2.039 1.606 1.606 0 0 0-2.026-1.038 1.62 1.62 0 0 0-1.033 2.038 1.606 1.606 0 0 0 2.027 1.039ZM90.231 14.468a3.631 3.631 0 0 0 .23-5.11 3.58 3.58 0 0 0-5.08-.23 3.631 3.631 0 0 0-.229 5.11 3.58 3.58 0 0 0 5.08.23ZM97.715 7.875c.617-.567.66-1.53.096-2.151a1.508 1.508 0 0 0-2.139-.097 1.529 1.529 0 0 0-.096 2.151c.564.621 1.522.664 2.139.097ZM11.683 92.408c.618-.567.66-1.53.097-2.15a1.508 1.508 0 0 0-2.14-.098 1.529 1.529 0 0 0-.095 2.151c.564.621 1.521.665 2.138.097Z",
    fill: "#0A0A0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.855 97.441c25.97 0 47.023-21.175 47.023-47.297 0-26.12-21.053-47.296-47.023-47.296-25.97 0-47.023 21.175-47.023 47.296 0 26.122 21.053 47.297 47.023 47.297Z",
    fill: "#181818"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#visitor-info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.738 7.797c-4.813-2.779-10.946-1.167-13.697 3.6L15.109 45.918c-2.752 4.767-1.081 10.884 3.732 13.662L62.415 84.74c4.813 2.78 10.946 1.168 13.698-3.599l19.932-34.523c2.752-4.766 1.081-10.883-3.732-13.662L48.738 7.797Z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.353 12.111c-6.145-1.253-12.133 2.664-13.374 8.75l-8.99 44.074c-1.241 6.086 2.734 12.035 8.879 13.288l55.63 11.348c6.145 1.253 12.133-2.664 13.374-8.75l8.99-44.074c1.242-6.086-2.733-12.035-8.878-13.288L28.353 12.11Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.878 22.889c-5.365 0-9.714 4.477-9.714 10v40c0 5.523 4.35 10 9.714 10H74.45c5.365 0 9.714-4.477 9.714-10v-40c0-5.523-4.35-10-9.714-10H25.878Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m34.612 44.802-.888 3.552h-4.557a1.563 1.563 0 0 0 0 3.125h41.667a1.563 1.563 0 0 0 0-3.125h-4.558l-.888-3.552c-1.137-4.547-1.705-6.821-3.4-8.145-1.696-1.323-4.04-1.323-8.727-1.323H46.74c-4.687 0-7.03 0-8.726 1.323-1.695 1.324-2.264 3.598-3.4 8.145Zm3.93 25.948a7.295 7.295 0 0 0 7.05-5.424l2.312-1.156a4.687 4.687 0 0 1 4.193 0l2.311 1.156a7.292 7.292 0 1 0-.053-3.52l-.86-.431a7.812 7.812 0 0 0-6.989 0l-.86.43a7.292 7.292 0 1 0-7.103 8.945Z",
    fill: "url(#visitor-info_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visitor-info_svg__b",
    x1: 50.521,
    y1: 70.75,
    x2: 50.521,
    y2: 35.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC2CA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBC2CA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "visitor-info_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })))));
};
export default SvgVisitorInfo;